var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixAddWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y9atz4a0fa",
    d: "M13 6H8V1c0-.55-.45-1-1-1S6 .45 6 1v5H1c-.55 0-1 .45-1 1s.45 1 1 1h5v5c0 .55.45 1 1 1s1-.45 1-1V8h5c.55 0 1-.45 1-1s-.45-1-1-1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-430 -449) translate(320 161) translate(0 181) translate(96 99) translate(17 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8wu5i3txub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y9atz4a0fa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#y9atz4a0fa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#8wu5i3txub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-3 -3)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixAddWhite);
export default __webpack_public_path__ + "static/media/ico-prefix-add-white.17a1974991e9fa5327fb538c0013e5ca.svg";
export { ForwardRef as ReactComponent };